var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6871 14.6246V11.2495C10.6871 11.1004 10.6278 10.9573 10.5223 10.8518C10.4168 10.7463 10.2738 10.687 10.1246 10.687H7.87459C7.7254 10.687 7.58233 10.7463 7.47684 10.8518C7.37135 10.9573 7.31209 11.1004 7.31209 11.2495V14.6246C7.31209 14.7738 7.25283 14.9168 7.14736 15.0223C7.04189 15.1278 6.89883 15.1871 6.74966 15.1871L3.37507 15.1876C3.3012 15.1876 3.22804 15.173 3.15979 15.1448C3.09154 15.1165 3.02952 15.0751 2.97728 15.0228C2.92504 14.9706 2.8836 14.9086 2.85532 14.8403C2.82705 14.7721 2.8125 14.6989 2.8125 14.6251V8.12393C2.8125 8.04556 2.82888 7.96806 2.86058 7.89639C2.89228 7.82472 2.9386 7.76047 2.99659 7.70775L8.6212 2.59358C8.72474 2.49944 8.85965 2.44727 8.99959 2.44727C9.13954 2.44726 9.27445 2.49942 9.378 2.59356L15.0034 7.70774C15.0614 7.76046 15.1077 7.82472 15.1394 7.8964C15.1711 7.96807 15.1875 8.04558 15.1875 8.12395V14.6251C15.1875 14.6989 15.1729 14.7721 15.1447 14.8403C15.1164 14.9086 15.075 14.9706 15.0227 15.0228C14.9705 15.0751 14.9085 15.1165 14.8402 15.1448C14.772 15.173 14.6988 15.1876 14.6249 15.1876L11.2495 15.1871C11.1003 15.1871 10.9573 15.1278 10.8518 15.0223C10.7463 14.9168 10.6871 14.7738 10.6871 14.6246V14.6246Z",
    stroke: "#1E1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.282e073f4a9beafb164dce2869b4a8c0.svg";
export { ForwardRef as ReactComponent };